import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";
import { de } from "@fancyapps/ui/dist/carousel/l10n/de.esm.js";
document.addEventListener("DOMContentLoaded", () => {
	const sliders = document.querySelectorAll(".indy-block-gallery-slider .f-carousel");

	for (const slider of sliders) {
		const wrapper = slider.closest('.indy-block-gallery-slider');
		new Carousel(slider, {
			l10n: de,
			infinite: true,
			Dots: false,
			transition: "slide",
			Navigation: true,
		});
	}

	const hero_sliders = document.querySelectorAll(".indy-block-hero__slider .f-carousel");

	for (const slider of hero_sliders) {
		new Carousel(slider, {
			l10n: de,
			infinite: true,
			Dots: true,
			Navigation: false,
			transition: "slide",

			Autoplay: {
				timeout: 4000,
			},
		}, {
			Autoplay,
		});
	}
});
